const resultOrderFormatter = (results_order) => {
  const formatOptions = {
    field_area_m2: 'room_size',
    field_title: 'name',
    price: 'price',
    asc: 'lowest',
    desc: 'highest',
  };

  const orderArray = results_order.split('.');
  if (orderArray[0] === 'random') {
    return 'random';
  }
  const sorting_type = formatOptions[orderArray[0]];
  const sorting_order = formatOptions[orderArray[1]];

  return `${sorting_order}_${sorting_type}_first`;
};

const priceFormatter = (price) => {
  return (Math.round(price * 100) / 100).toFixed(2);
};

const dateFormatter = (dateObject) => {
  return dateObject.format('DD-MM-YYYY');
};

const clearPreviousSearch = async (dataLayer) => {
  dataLayer.push({ ecommerce: null });
  dataLayer.push({ terms: null });
}

const sendSkiInnEvent = async (
  dataLayer,
  eventName,
  startDate,
  endDate,
  adults,
  children,
  infants,
  pets,
  resultSorting,
  activeThemeFilters,
  activeSizeFilters,
  activeFacilityFilters,
  activeDepartmentsFilter,
  range_lift,
  range_skitrail,
  range_village,
  productsLength,
  selectedPopularDate
) => {
  try {
    let duration;
    if (startDate && endDate) {
      duration = endDate.diff(startDate, 'days');
    }

    const results_order = resultOrderFormatter(resultSorting);

    const terms = {
      adults: adults,
      children: children,
      infants: infants,
      pets: pets,
      results: productsLength,
      results_order,
    };

    if (startDate) {
      terms.start_date = dateFormatter(startDate);
    }

    if (endDate) {
      terms.end_date = dateFormatter(endDate);
    }

    if (duration) {
      terms.visit_length = duration;
    }

    if (range_lift) {
      terms.range_lift = range_lift;
    }

    if (range_skitrail) {
      terms.range_skitrail = range_skitrail;
    }

    if (range_village) {
      terms.range_village = range_village;
    }

    if (selectedPopularDate.name) {
      terms.featured = {
        name: selectedPopularDate.name,
        startTime: dateFormatter(selectedPopularDate.startDate),
        endTime: dateFormatter(selectedPopularDate.endDate),
      };
    }
    if (activeFacilityFilters.length) {
      terms.configuration = [...new Set(activeFacilityFilters)];
    }

    if (activeDepartmentsFilter.length) {
      terms.departments = [... new Set(activeDepartmentsFilter)];
    }

    if (activeSizeFilters.length) {
      terms.bedrooms = [...new Set(activeSizeFilters)];
    }

    if (activeThemeFilters.length) {
      terms.theme = [...new Set(activeThemeFilters)];
    }

    const customDataLayer = { event: eventName, terms: terms };

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.error(`error: ${e}`);
  }
};

const sendTravelEvent = async (
  dataLayer,
  eventName,
  startDate,
  endDate,
  adults,
  children,
  resultSorting,
  activeSizeFilters,
  activeFacilityFilters,
  range_lift,
  range_skitrail,
  range_village,
  numberOfResults,
  selectedPopularDate
) => {
  try {
    let duration;
    if (startDate && endDate) {
      duration = endDate.diff(startDate, 'days');
    }

    const results_order = resultOrderFormatter(resultSorting);

    const terms = {
      adults: adults,
      children: children,
      results: numberOfResults,
      results_order,
    };

    if (startDate) {
      terms.start_date = dateFormatter(startDate);
    }
    if (endDate) {
      terms.end_date = dateFormatter(endDate);
    }
    if (duration) {
      terms.visit_length = duration;
    }

    if (range_lift) {
      terms.range_lift = range_lift;
    }

    if (range_skitrail) {
      terms.range_skitrail = range_skitrail;
    }

    if (range_village) {
      terms.range_village = range_village;
    }

    if (selectedPopularDate.name) {
      terms.featured = {
        name: selectedPopularDate.name,
        startTime: dateFormatter(selectedPopularDate.startDate),
        endTime: dateFormatter(selectedPopularDate.endDate),
      };
    }

    if (activeFacilityFilters.length) {
      terms.configuration = [...new Set(activeFacilityFilters)];
    }

    if (activeSizeFilters) {
      terms.bedrooms = [...new Set(activeSizeFilters)];
    }

    const customDataLayer = { event: eventName, terms: terms };

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.error(`error: ${e}`);
  }
};

const sendEcommerceEvent = async (
  dataLayer,
  eventName,
  isSkiInn,
  item_name,
  price,
  departmentName,
  housingType,
  companyName
) => {
  try {
    let item;
    let item_list_name;

    try {
      if (isSkiInn) {
        // Ski-Inn product
        item = {
          item_name: `Ski-Inn ${item_name}`,
          item_brand: 'Ski-Inn',
          affiliation: 'Ski-Inn',
          currency: 'EUR',
        };

        if (departmentName && departmentName.en) {
          item.item_category = `Ski-Inn ${departmentName.en}`;
        }

        if (housingType && housingType.en) {
          item.item_category2 = `Ski-Inn ${housingType.en}`;
        }
        item_list_name = 'ski-inn-results';
      } else {
        // Travelsearch product
        item = {
          item_name: item_name,
          item_brand: companyName,
          item_category2: `${housingType}`,
          affiliation: 'Travel Search',
          currency: 'EUR',
          quantity: 1,
        };
        item_list_name = 'travel-search-results';
      }
    } catch (e) {
      console.error(`error: ${e}`);
    }

    const customDataLayer = {
      event: eventName,
      ecommerce: {
        currency: 'EUR',
        item_list_name,
        items: [item],
      },
    };

    if (price) {
      customDataLayer.ecommerce.items[0].price = priceFormatter(price);
    }

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.error(`error: ${e}`);
  }
};

const ecommerceViewItemList = async (
  dataLayer,
  isSkiInn,
  products,
  accommodationProviders = null
) => {
  try {
    let itemProducts = [];
    const item_list_name = isSkiInn
      ? 'ski-inn-results'
      : 'travel-search-results';

    if (isSkiInn) {
      itemProducts = products.map((product) => {
        let item_category;
        let item_category2;

        if (product.field_capacity.name && product.field_capacity.name.en) {
          item_category = product.field_capacity.name.en;
        }

        if (product.field_housing_type_list.length) {
          item_category2 = product.field_housing_type_list[0].en;
        }

        const item_name = product.roomName
          ? `Ski-Inn ${product.roomName}`
          : `${product.field_title.en}`;

        let prod = {
          item_name,
          item_brand: 'Ski-Inn',
          item_list_name,
          affiliation: 'Ski-Inn',
          quantity: 1,
        };

        if (item_category) {
          prod.item_category = `Ski-Inn ${item_category}`;
        }

        if (item_category2) {
          prod.item_category2 = `Ski-Inn ${item_category2}`;
        }

        if (product.price) {
          prod.price = priceFormatter(product.price);
        }

        return prod;
      });
    } else {
      // Get products by accommodation provider, since we want to only
      // send the first three if the products are grouped.
      accommodationProviders.forEach((accommodationProvider) => {
        let filteredProducts = products.filter(
          (product) =>
            product.accommodationProvider.id === accommodationProvider.id
        );

        // Only one results for each bundled result is pushed
        if (accommodationProvider.groupResults) {
          filteredProducts = filteredProducts.slice(0, 1);
        }

        filteredProducts.forEach((filteredProduct) => {
          const item_category2 = filteredProduct.Fields.find((field) => {
            return field.Name === 'HousingType';
          }) ?? '';
          itemProducts.push({
            item_name: filteredProduct.accommodationProvider.groupResults
              ? filteredProduct.accommodationProvider.name
              : filteredProduct.Name,
            item_brand: filteredProduct.CompanyName,
            item_category2: item_category2.Value ?? '',
            item_list_name,
            affiliation: 'Travel Search',
            price: priceFormatter(filteredProduct.Price.Price),
            quantity: 1,
          });
        });
      });
    }

    const customDataLayer = {
      event: 'view_item_list',
      ecommerce: {
        currency: 'EUR',
        items: [...itemProducts],
      },
    };

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.error(`error: ${e}`);
  }
};

const sendEventSearchToGA4 = async (
  dataLayer,
  startDate,
  endDate,
  search_keyword,
  search_tags,
  search_category,
  search_action,
  results
) => {
  try {
    const customDataLayer = {
      event: 'events_search',
      terms: {},
    };

    if (startDate) {
      customDataLayer.terms.startDate = startDate;
    }

    if (endDate) {
      customDataLayer.terms.endDate = endDate;
    }

    if (search_keyword) {
      customDataLayer.terms.search_keyword = search_keyword;
    }

    if (search_tags.length > 0) {
      customDataLayer.terms.search_tags = search_tags;
    }

    if (search_category) {
      customDataLayer.terms.search_category = search_category;
    }

    if (search_action) {
      customDataLayer.terms.search_action = search_action;
    }

    if (results) {
      customDataLayer.terms.results = results;
    }

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.error(`error: ${e}`);
  }
};

const sendSiteSearchToGA4 = async (dataLayer, search_keyword, results) => {
  try {
    const customDataLayer = {
      event: 'site_search',
      terms: {
        search_keyword,
        results,
      },
    };

    await clearPreviousSearch(dataLayer);
    dataLayer.push(customDataLayer);
  } catch (e) {
    console.log(`error: ${e}`);
  }
};

export {
  sendSkiInnEvent,
  sendTravelEvent,
  sendEcommerceEvent,
  ecommerceViewItemList,
  sendEventSearchToGA4,
  sendSiteSearchToGA4,
};
